import { api } from "./api";

const VKEY = "dakid_viewer_id";

export const getViewerId = () => {
  let id = localStorage.getItem(VKEY);
  if (!id) {
    id = (window.crypto && crypto.randomUUID)
      ? crypto.randomUUID()
      : `v_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(VKEY, id);
  }
  return id;
};

const recentViews = {}; // episodeId -> { ts, promise } — dedupe rapid duplicate starts (StrictMode / double effects)

export const startView = (episodeId) => {
  const now = Date.now();
  const cached = recentViews[episodeId];
  if (cached && now - cached.ts < 4000) return cached.promise;
  const promise = api
    .post("/analytics/view", { episode_id: episodeId, viewer_id: getViewerId() })
    .then((r) => r.data.session_id)
    .catch(() => null);
  recentViews[episodeId] = { ts: now, promise };
  return promise;
};

export const sendProgress = (sessionId, watchedSeconds, percent) => {
  if (!sessionId) return;
  const body = { session_id: sessionId, watched_seconds: watchedSeconds, percent };
  // Prefer keepalive-capable fetch so it survives page unload/navigation
  try {
    const url = `${api.defaults.baseURL}/analytics/progress`;
    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
      keepalive: true,
    }).catch(() => {});
  } catch {
    api.post("/analytics/progress", body).catch(() => {});
  }
};

// ---- Website visitor analytics (privacy-friendly: anonymous IDs only) ----
const SKEY = "dakid_session_id";

// A session id lives for the browser tab session (resets when the tab is closed),
// so we can count "visits/sessions" distinctly from all-time "unique visitors".
export const getSessionId = () => {
  let id = sessionStorage.getItem(SKEY);
  if (!id) {
    id = (window.crypto && crypto.randomUUID)
      ? crypto.randomUUID()
      : `s_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    sessionStorage.setItem(SKEY, id);
  }
  return id;
};

const recentVisits = {}; // path -> ts — dedupe rapid duplicate page views
export const trackVisit = (path) => {
  const now = Date.now();
  if (recentVisits[path] && now - recentVisits[path] < 2000) return;
  recentVisits[path] = now;
  api
    .post("/analytics/visit", { visitor_id: getViewerId(), session_id: getSessionId(), path })
    .catch(() => {});
};

// ---- Real-time "Watching Now" presence (only while the video is playing) ----
let hbTimer = null;
let hbEpisode = null;

export const startHeartbeat = (episodeId) => {
  if (hbTimer && hbEpisode === episodeId) return; // already beating for this episode
  stopHeartbeat();
  hbEpisode = episodeId;
  const ping = () =>
    api.post("/analytics/heartbeat", { session_id: getSessionId(), episode_id: episodeId }).catch(() => {});
  ping(); // immediate so the admin sees it fast
  hbTimer = setInterval(ping, 10000);
};

export const stopHeartbeat = () => {
  if (hbTimer) { clearInterval(hbTimer); hbTimer = null; }
  hbEpisode = null;
  const sid = getSessionId();
  const body = JSON.stringify({ session_id: sid });
  try {
    const url = `${api.defaults.baseURL}/analytics/stop`;
    if (navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([body], { type: "application/json" }));
    } else {
      fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true }).catch(() => {});
    }
  } catch {}
};
